import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "./header.css";

interface Props {
    categories: string[]
}

function LogoIcon() {
    return <svg id="Do7sCdyQw_" viewBox="0 0 390 107">
        <defs id="SvgjsDefs1158"></defs>
        <g id="SvgjsG1159" feature-key="rootContainer" transform="matrix(1,0,0,1,0,0)"
            fill="#6a2c70">
            <rect xmlns="http://www.w3.org/2000/svg" width="390" height="107" rx="10" ry="10">
            </rect>
        </g>
        <g id="SvgjsG1160" feature-key="q4o0QG-0"
            transform="matrix(4.3695381606415244,0,0,4.3695381606415244,17.727840239808735,-1.7603001233371174)"
            fill="#ffffff">
            <path
                d="M0.52 20 l0.24 -14.5 l2.38 -0.18 l1.08 0.12 l1.02 6.94 l0.6 -7.16 l4.1 0.5 c0.02 0.76 0.04 1.54 0.04 2.36 c0.08 1.38 0.18 3.18 0.18 4.84 c0.06 2.68 -0.02 4.6 0.16 7.12 l-1.76 -0.04 l-0.14 -8.98 l-0.38 -0.08 l-1 7.96 l-0.34 0.98 l-2.12 0.12 l-1.02 -8.4 l-0.6 0.14 l0.22 8.38 z M11.58 19.92 l-0.04 -6.94 l0.08 -0.74 l-0.04 -0.74 l0.1 -4.42 l0.18 -1.72 l6.5 0.12 l0.1 3.9 l-4.26 0 l-0.08 2.5 l3.26 -0.06 l0 0.22 l0.1 1.7 l-3.04 0.06 l0.1 2.96 l4.06 0.2 l0 3.08 z M25.820000000000004 12.64 l2.42 7.52 l-1.08 0 l-2.14 -0.1 l-1.46 -5.36 l-1.06 5.34 l-1.28 0.22 l-2.32 -0.22 l2.42 -7.38 l-2.42 -7.48 l1.9 0 l1.28 0.1 l1.06 4.96 l0.48 0.32 l0.38 -5.38 l1.54 -0.1 l2.7 0.14 l-2.42 7.1 l0 0.32 z M29.060000000000006 19.92 l-0.04 -6.94 l0.08 -0.74 l-0.04 -0.74 l0.1 -4.42 l0.18 -1.72 l6.5 0.12 l0.1 3.9 l-4.26 0 l-0.08 2.5 l3.26 -0.06 l0 0.22 l0.1 1.7 l-3.04 0.06 l0.1 2.96 l4.06 0.2 l0 3.08 z M38.88000000000001 7.699999999999999 l0.06 1.58 l0 2.06 l0.72 0 l0.7 -0.06 l0.46 -0.44 l0 -0.2 l0.08 -1.36 l-0.16 -1.22 l0 -0.04 l-0.22 -0.8 l-0.54 -0.24 l-1.04 0 z M38.760000000000005 5.24 l2.62 0.04 l1.24 0.14 l1.02 0.58 l0.8 1.32 l-0.26 3.86 l-0.32 0.6 l-1.18 0.38 l1.34 1 l0.36 0.98 l0 1.6 l-0.18 4.24 l-0.52 0.12 l-2.06 -0.1 l-0.1 -3.9 l-0.14 -2.06 l-0.48 -0.52 l-0.92 -0.3 l0 1.48 l0 3.72 l0.06 1.56 l-1.94 -0.02 l-0.92 0.06 l-0.32 -0.06 l0 -2.88 l0 -2.1 l0.12 -2.72 l-0.08 -4.68 l-0.04 -2.32 z M45.760000000000005 8.88 l3.2 0.08 l-0.16 2.5 l0.24 5.08 l-0.14 3.38 l-0.28 0.04 l-2.8 -0.06 l-0.12 -0.92 l-0.04 -5.36 z M45.88 4.98 l3.02 0.04 l0.14 0.78 l0 1.34 l-0.08 0.72 l-3.2 0.02 l-0.1 -1.3 l-0.04 -1.4 z M57.52 5.380000000000001 l0.52 0.34 l0.4 1.72 l0 2.84 l-0.36 6.42 l-0.64 1 l-0.46 0.2 l-2.8 -0.02 l-0.12 0.26 l0.86 0.4 l2.46 0.02 l0.2 1.58 l-1.82 0 l-1.7 0 l-1.22 -0.2 l-0.7 -0.66 l-0.22 -0.96 l0.1 -0.46 l-0.44 0 l-0.92 -0.68 l-0.14 -0.76 l0 -7.84 l0.44 -2.84 l1.46 -0.48 l2.22 -0.04 z M54.56 15.780000000000001 l1.42 -0.44 l0.2 -8.38 l-1.8 -0.16 l-0.52 0.3 l-0.02 5.38 l0.18 2.22 l0 0.44 l0.1 0.48 z M59.92 17.44 l0.1 -11.92 l0.78 -0.34 l2.4 0.14 l0.54 0.2 l-0.2 4.7 l-0.24 7.34 l0.8 1.08 l1.52 -0.32 l-0.12 -8.5 l0.12 -4.62 l1.9 0 l0.06 12.98 l-0.54 1.32 l-2.5 0.72 l-3.6 -0.5 z M69.18 19.92 l-0.04 -6.94 l0.08 -0.74 l-0.04 -0.74 l0.1 -4.42 l0.18 -1.72 l6.5 0.12 l0.1 3.9 l-4.26 0 l-0.08 2.5 l3.26 -0.06 l0 0.22 l0.1 1.7 l-3.04 0.06 l0.1 2.96 l4.06 0.2 l0 3.08 z M77.34 8.88 l3.2 0.08 l-0.16 2.5 l0.24 5.08 l-0.14 3.38 l-0.28 0.04 l-2.8 -0.06 l-0.12 -0.92 l-0.04 -5.36 z M77.46000000000001 4.98 l3.02 0.04 l0.14 0.78 l0 1.34 l-0.08 0.72 l-3.2 0.02 l-0.1 -1.3 l-0.04 -1.4 z">
            </path>
        </g>
    </svg>;
}

export function Header(props: Props) {
    const [menuState, setMenuState] = useState(false);
    const [mobileInputState, setMobileInputState] = useState(false);
    const [searchText, setSearchText] = useState("");
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
    }, [location]);

    function handleSearch() {
        if (searchText.length === 0)
            return;

        navigate(`/pesquisa/${searchText}`);
        setSearchText("");
    }

    return <header className="header">
        <div className="header-content content-center">
            <div className="container">
                <button className="open-menu-button" onClick={() => setMenuState(true)}>
                    <i className="material-symbols-outlined">menu</i>
                </button>
                <div className="logo">
                    <a href="/">
                        {// verify if its a post page, because post page needs the h1 tag
                        !location.pathname.includes("/posts/") ?
                            <h1 className="logo-content">
                                {LogoIcon()}
                                Mexeriquei
                            </h1>
                            :
                            <span className="logo-content">
                                {LogoIcon()}
                                Mexeriquei
                            </span>
                        }
                    </a>
                </div>
                <div className="input-button internal">
                    <input
                        className="search-input"
                        type="text"
                        name="search-input"
                        id="search-input"
                        placeholder="O que você procura?"
                        value={searchText}
                        onChange={e => setSearchText(e.target.value)}
                    />
                    <button className="search-button" onClick={() => handleSearch()}>
                        <i className="material-symbols-outlined">search</i>
                    </button>
                </div>
                <div className={`mobile-input-button ${mobileInputState ? "active" : ""}`}>
                    <div className="input-block-touch"></div>
                    <button className="mobile-search-button" onClick={() => setMobileInputState(true)}>
                        <i className="material-symbols-outlined">search</i>
                    </button>
                    <button className="mobile-back-button" onClick={() => setMobileInputState(false)}>
                        <i className="material-symbols-outlined">arrow_back</i>
                    </button>
                    <input
                        className="mobile-search-input"
                        type="text"
                        name="search-input"
                        id="search-input-mobile"
                        placeholder="O que você procura?"
                        value={searchText}
                        onChange={e => setSearchText(e.target.value)}
                        onKeyUp={(value) => {
                            if (value.code !== 'Enter' && value.which !== 13)
                                return;

                            handleSearch();
                        }}
                    />
                </div>
            </div>
        </div>
        <div className={`menu content-center ${menuState ? "active" : ""}`}>
            <div className="input-block-touch"></div>
            <div className="container">
                <div className="menu-header">
                    <div className="category-menu-title">
                        {LogoIcon()}
                    </div>
                    <button className="close-menu-button" onClick={() => setMenuState(false)}>
                        <i className="material-symbols-outlined">
                            close
                        </i>
                    </button>
                </div>
                <ul className="category-menu-items">
                    <li className="category-menu-item">
                        <a href="/">Início</a>
                    </li>
                    {props.categories.map((category, index) => (
                        <li className="category-menu-item" key={index}>
                            <Link to={`/categorias/${category}`} onClick={() => setMenuState(false)}>{category}</Link>
                        </li>
                    ))}
                    <li className="category-menu-item">
                        <a href="/horoscopo">Horóscopo</a>
                    </li>
                </ul>
            </div>
        </div>
    </header>
}